import * as Sentry from '@sentry/angular';
import { OperatorFunction, catchError, of, pipe, retry, timer } from 'rxjs';

/**
 * Retries a failing source with linear backoff, then reports the last error to
 * Sentry and emits `null` — so the stream completes instead of erroring and a
 * failed request can't tear down a long-lived subscription.
 *
 * @param count Retry attempts made after the initial one.
 */
export function handleWithRetryAndError<T>(
  count = 3,
): OperatorFunction<T, T | null> {
  return pipe(
    retry({
      count,
      delay: (_error, retryCount) => timer(1000 * retryCount),
    }),
    catchError((error: unknown) => {
      Sentry.captureException(error);
      return of(null);
    }),
  );
}
